export default __webpack_public_path__ + "static/media/intro_image_1.54a50bd5.jpg";